import { useState } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Done as DoneIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ModalConfirmation from '../../layout/ModalConfirmation';

type SttButtonAcceptProps = {
    caption?: string;
    onClick?: () => void | Promise<void>;
    confirmation?: boolean;
} & Omit<ButtonProps, 'onClick'>;

/**
 * Accept button
 */
export function SttButtonAccept({
    caption,
    onClick,
    confirmation = false,
    ...rest
}: SttButtonAcceptProps) {
    const { t } = useTranslation();
    const [confirmationDialog, setConfirmationDialog] = useState({
        show: false,
    });

    return (
        <>
            <Button
                {...rest}
                variant="contained"
                color="primary"
                startIcon={<DoneIcon />}
                onClick={
                    confirmation
                        ? () => setConfirmationDialog({ show: true })
                        : onClick
                }
            >
                {caption || t('Accept')}
            </Button>
            <ModalConfirmation
                show={confirmationDialog.show}
                onClose={() => setConfirmationDialog({ show: false })}
                onAccept={() => {
                    onClick?.();
                    setConfirmationDialog({ show: false });
                }}
            />
        </>
    );
}
